import React, { Component } from 'react';

export default class Home extends Component {
    static displayName = Home.name;

    render() {
        return (
            <div>
                <p>
                    Welcome to the Gross Receipt Taxpayer Portal.
                    <br />
                    <br />
                    To file a return, search for your account from the "Account Search" page using your account number and PIN.
                    <br />
                    <br />
                    If you do not yet have a PIN, you can request one by printing the PIN request form from the "Request PIN" page, filling it out, and mailing it to the county tax office.
                </p>
            </div>
        );
    }
}
